import React from 'react'
import { renderWithRoot } from '../common/react-root-helper'
import { getState, subscribe } from '../store'
import appActions from '../actions/app'
import App from '../common/app'
import VendorList from './components/index'

function render (mountNode) {
    return function () {
      renderWithRoot(
        <App active="vendor-list" {...getState()} {...appActions}>
          <VendorList {...getState()} {...appActions} />
        </App>,
        mountNode
      )
    }
  }
  
  let unsubscribe = function () {}
  
  export default function (app, mountNode) {
    app('/vendor-list', context => {
      unsubscribe = subscribe(render(mountNode))  
      render(mountNode)()
    })
  
    app.exit('/vendor-list', (context, next) => {
      unsubscribe()
      next()
    })
  }